import Link from "next/link";
import * as React from "react";

import styles from "./Logo.module.css";
// @ts-ignore
import { home } from "../routes";
import { useNewBrandStyle } from "../hooks/useNewBrandStyle";

interface LogoProps {
  disableLinkToHome?: boolean;
}

export function HomeLink(props: LogoProps & { children: React.ReactChild }) {
  if (props.disableLinkToHome) {
    return <div className={styles.root}>{props.children}</div>;
  }
  return (
    <div className={styles.root}>
      <Link {...home()}>
        <a>{props.children}</a>
      </Link>
    </div>
  );
}

export default function Logo(props: LogoProps) {
  const assetPrefix = process.env.ASSET_PREFIX || "";
  const isNewBrandEnabled = useNewBrandStyle();

  const logoFilePath = isNewBrandEnabled ? "new-brand/logo.svg" : "logo.svg";

  return (
    <HomeLink disableLinkToHome={props.disableLinkToHome}>
      <img
        src={`${assetPrefix}/static/${logoFilePath}`}
        alt="logo"
        data-qa="blacklaneLogo"
      />
    </HomeLink>
  );
}
